import { FormInput, useFormContext } from "@4uhub/lib4uhub";
import { memo, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTotemDeviceForm } from "../totemDeviceSchema";
import { Grid } from "@mui/material";

const translationPath = "page.register.totemDevice.";

export const DevicePasswordInput = memo(() => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<TTotemDeviceForm>();

  const changePassword = useWatch({
    name: "changePassword",
    control,
  });

  useEffect(() => {
    if (changePassword) {
      setValue("devicePassword", null);
    }
  }, [changePassword, setValue]);

  return changePassword ? (
    <Grid item xs={12} sm={6}>
      <FormInput
        size="small"
        name="devicePassword"
        fullWidth
        label={t(translationPath + "device_password") || "Device Password"}
      />
    </Grid>
  ) : null;
});
